import React, { useState } from 'react';
import StepWizard from 'react-step-wizard';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@naf-simba/elements-buttons';
import { useNavigate, useLocation } from 'react-router-dom';
import { Text, TextVariant } from '@naf/text';
import { ProgressBar } from '@naf-simba/elements-progress-bar';
import * as S from '../Styles';
import { SelectVehicleStep } from './selectVehicleStep/SelectVehicleStep';
import { SelectWorkProposalStep } from './selectWorkProposalStep/SelectWorkProposalStep';
import { CenterProductArticleType } from '../../../../../../types/centerProductArticleType';
import BreadCrumb from '../../../../components/breadcrumb/BreadCrumb';
import { useTrackCTA } from '../../../../utils/Tracking/CtaClick/TrackCtaClick';
import { useLoginRedirect } from '../../../../hooks/useLoginRedirect';
import { useTrackPromotion } from '../../../../hooks/useTrackPromotion';

interface WizardProps {
  isMember: boolean;
  centerId: number;
  centerProductArticle: CenterProductArticleType;
}

export const Wizard = ({ isMember, centerId, centerProductArticle }: WizardProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const trackCTA = useTrackCTA();
  const { isAuthenticated } = useAuth0();
  const { redirectToLoginPage } = useLoginRedirect();
  const { title } = (centerProductArticle as CenterProductArticleType) || {};
  const [progressBarCompletedPercent, setProgressBarCompletedPercent] = useState(25);
  const [progressBarLabel, setProgressBarLabel] = useState('Velg senter og bil');
  const ctaText = 'Bli medlem';
  const { wrapperRef, trackSelectPromotion } = useTrackPromotion({
    creative_slot: 'naf-senter-servicekalkulator',
    creative_name: `CTA | signature | ${ctaText}`,
  });

  const updateProgressBarCompletedPercent = (value: number) => {
    setProgressBarCompletedPercent(value);
  };

  const updateProgressBarLabel = (value: string) => {
    setProgressBarLabel(value);
  };

  return (
    <S.StyledWrapper>
      <BreadCrumb paddingTop={false} />
      <Text variant={TextVariant.Header1}>{title}</Text>
      {(!isAuthenticated || !isMember) && (
        <Text variant={TextVariant.BodyText}>Tjenesten er kun tilgjengelig for NAF-medlemmer.</Text>
      )}
      {!isMember && (
        <div ref={wrapperRef}>
          <Button
            onClick={() => {
              trackSelectPromotion();
              trackCTA({ cta_position: 'content', text: ctaText, url: '/bli-medlem' });
              navigate('/bli-medlem');
            }}
            style={{ marginRight: 16, marginTop: 16 }}
          >
            {ctaText}
          </Button>
        </div>
      )}
      {!isAuthenticated && (
        <Button
          variant="outlined"
          onClick={() => {
            trackCTA({ cta_position: 'content', text: 'Logg inn' });
            redirectToLoginPage(location.pathname);
          }}
          style={{ marginTop: 16 }}
        >
          Logg inn
        </Button>
      )}
      {isAuthenticated && isMember && (
        <StepWizard
          transitions={{}}
          isLazyMount
          nav={<ProgressBar completedPercent={progressBarCompletedPercent} label={progressBarLabel} />}
        >
          <SelectVehicleStep
            nafCenterId={centerId}
            onUpdateProgressBarCompletedPercent={updateProgressBarCompletedPercent}
            onUpdateProgressBarLabel={updateProgressBarLabel}
          />
          <SelectWorkProposalStep
            onUpdateProgressBarCompletedPercent={() => updateProgressBarCompletedPercent(75)}
            onUpdateProgressBarLabel={() => updateProgressBarLabel('Velg utstyrspakke')}
          />
        </StepWizard>
      )}
    </S.StyledWrapper>
  );
};
